const Legal = () => {
  const sections = [
    {
      title: "Angaben gemäß § 5 TMG",
      content: (
        <div className="space-y-2">
          <div className="space-y-1">
            <p>Angel & Devil Agency LLC</p>
            <p>7901 4th St N</p>
            <p>St. Petersburg, FL 33702</p>
            <p>USA</p>
          </div>
          <div className="space-y-2 mt-4">
            <p>
              📧 E-Mail:{" "}
              <a
                href="mailto:info@angel-devil.network"
                className="text-hot-pink hover:text-accent-purple transition-colors"
              >
                info@angel-devil.network
              </a>
            </p>
            <p>
              📞 Telefon:{" "}
              <a
                href="tel:+13057776989"
                className="text-hot-pink hover:text-accent-purple transition-colors"
              >
                +1 305 777 6989
              </a>
            </p>
            <p>
              🌐 Website:{" "}
              <a
                href="https://www.angel-devil.network"
                className="text-hot-pink hover:text-accent-purple transition-colors"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.angel-devil.network
              </a>
            </p>
          </div>
        </div>
      ),
    },
    {
      title: "Vertreten durch",
      content: (
        <p>Geschäftsführer: Victor Engelmann</p>
      ),
    },
    {
      title: "Haftungsausschluss (Disclaimer)",
      subsections: [
        {
          subtitle: "1. Haftung für Inhalte",
          content:
            "Wir erstellen die Inhalte unserer Seiten mit größter Sorgfalt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen.",
        },
        {
          subtitle: "2. Haftung für Links",
          content:
            "Unsere Website enthält Links zu externen Websites Dritter. Auf deren Inhalte haben wir keinen Einfluss und übernehmen dafür keine Haftung. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber verantwortlich.",
        },
      ],
    },
    {
      title: "Urheberrecht",
      content:
        "Die durch Angel & Devil Network erstellten Inhalte und Werke auf diesen Seiten unterliegen dem Urheberrecht. Beiträge Dritter sind als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.",
    },
    {
      title: "Streitbeilegung",
      content: (
        <div className="space-y-2">
          <p>
            Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung
            (OS) bereit:{" "}
            <a
              href="https://ec.europa.eu/consumers/odr"
              className="text-hot-pink hover:text-accent-purple transition-colors"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://ec.europa.eu/consumers/odr
            </a>
            .
          </p>
          <p>Unsere E-Mail-Adresse findest du oben im Impressum.</p>
        </div>
      ),
    },
  ];

  return (
    <div className="pt-20">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Impressum – <span className="text-gradient">Angel & Devil Network</span>
            </h1>
            <p className="text-xl text-white/80">
              Where{" "}
              <span className="text-hot-pink">Temptation</span> Meets{" "}
              <span className="text-accent-purple">Talent</span>
            </p>
          </div>
        </div>
      </section>

      {/* Content Sections */}
      <section>
        <div className="w-full">
          <div className="space-y-20">
            {sections.map((section, index) => (
              <div key={index} className={`flex ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                <div className="relative w-full">
                  <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                  <div className="relative glass-effect rounded-2xl p-8">
                    <div className="flex items-start gap-6">
                      <div className="shrink-0">
                        <div className="w-12 h-12 rounded-xl bg-gradient-to-r from-hot-pink to-accent-purple flex items-center justify-center">
                          <span className="text-white text-xl">{index + 1}</span>
                        </div>
                      </div>
                      <div>
                        <h2 className="text-2xl font-playfair text-gradient mb-4">
                          {section.title}
                        </h2>
                        {section.subsections ? (
                          <div className="space-y-6">
                            {section.subsections.map((subsection, subIndex) => (
                              <div key={subIndex} className="space-y-2">
                                <h3 className="text-xl text-white font-medium">
                                  {subsection.subtitle}
                                </h3>
                                <div className="text-white/80">{subsection.content}</div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="text-white/80">{section.content}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Contact Section */}
        <div className="w-full mt-20 text-center">
          <p className="text-white/80">
            Angel & Devil Network – Where{" "}
            <span className="text-hot-pink">Temptation</span> Meets{" "}
            <span className="text-accent-purple">Talent</span>.
          </p>
          <p className="text-white/80 mt-4">
            Hast du Fragen? Kontaktiere uns unter{" "}
            <a
              href="mailto:info@angel-devil.network"
              className="text-hot-pink hover:text-accent-purple transition-colors"
            >
              info@angel-devil.network
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Legal;
